<template>
  <div class="empty-state mt-4 flex justify-center rounded-lg">
    <p class="empty-state-text">
      {{ text }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'EmptyStateBox',
  props: {
    text: {
      type: String,
      default: '',
    },
  },
};
</script>
<style scoped>
.empty-state-box {
  padding: 25px 16px !important;
}
</style>
